import React from "react"
import { Row, Col } from "react-bootstrap"

import PanelWrapper from "../../internal/panelWrapper/PanelWrapper";
import SpeakerWidget from "../../widgets/speakerWidget/SpeakerWidget";

const twoColumnSpeaker = ( {blok} ) => {
  return ( 
    <PanelWrapper blok={blok}>
      <Row>
        {blok.speakers ? blok.speakers.map(speaker=>{
          return( 
            <Col md={6}>
              <SpeakerWidget blok={speaker}/>
          </Col>)
        }) : null }
      </Row>
    </PanelWrapper>
  );
}
 
export default twoColumnSpeaker;